<div class="fx-column">
  <div class="fx-row align-items-center justify-content-between">
    <app-back></app-back>
    <div class="fx-row align-items-center justify-content-end">
      @if (selection && selection.selected && selection.selected.length > 0) {
        <button class="danger-button" (click)="deleteDocuments()">
          <span class="danger">
            {{ 'ACTIONS.DELETE' | translate }} {{ selection.selected.length }} {{
              ((selection.selected.length > 1
                ? 'INTEGRATIONS.BACKLINK_CRAWLER.URLS'
                : 'INTEGRATIONS.BACKLINK_CRAWLER.URL') | translate).toLowerCase()
            }}
          </span>
        </button>
      }
    </div>
  </div>
  <div class="fx-row align-items-center justify-content-between">
    <div class="fx-row align-items-center justify-content-start">
      <div class="fx-column">
        <span class="page-title">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.DISCOVERED_URLS_TITLE' | translate}}</span>
        <span class="page-subtitle">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.DISCOVERED_URLS_DESCRIPTION' | translate}}</span>
      </div>
    </div>
  </div>
  <mat-divider class="mv-20"></mat-divider>
  @if (!loading && done) {
    <mat-card class="p-0">
      <div class="fx-row align-items-center justify-content-between p-16">
        <div class="fx-row align-items-center justify-content-start">
          <div class="fx-row fw-wrap align-items-baseline justify-content-start ml-10">
            <app-animated-number [value]="discoveredBacklinksPaginator.totalDocs" [class]="'bold main'"></app-animated-number>
            &nbsp;
            <span class="text"><span class="bold main">{{
                ((discoveredBacklinksPaginator.totalDocs > 1
                  ? 'INTEGRATIONS.BACKLINK_CRAWLER.URLS'
                  : 'INTEGRATIONS.BACKLINK_CRAWLER.URL')
                  | translate
                )
              }}</span> {{ ('UTILS.MATCHING' | translate).toLowerCase() }}  </span>
          </div>
        </div>
        <div class="fx-row align-items-center justify-content-start">
          <app-select initial="none" (change)="onDepthChange($event)" class="mr-10"
                      [label]="'INTEGRATIONS.BACKLINK_CRAWLER.DEPTH' | translate"
                      [options]="depthSelectOptions"></app-select>
          <app-input placeholder="{{ 'ACTIONS.SEARCH' | translate }}..." type="text" prefix="search"
                     [(value)]="filters.query" (change)="onQueryChange()" style="width:210px;"></app-input>
        </div>
      </div>
      <mat-divider></mat-divider>
      <table mat-table [dataSource]="discoveredBacklinksPaginator.docs" style="z-index: 0;" matSort
             (matSortChange)="onSortChange($event)">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" color="primary"
                          [checked]="hasPageSelection() && isAllSelected()" [indeterminate]="hasPageSelection() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="$event ? toggle(row) : null"
                          [checked]="isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="url">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{'INTEGRATIONS.BACKLINK_CRAWLER.URL' | translate}}
          </span>
          </th>
          <td mat-cell *matCellDef="let discoveredUrl">
            <a target="_blank" [href]="discoveredUrl.url"
               class="text bold">{{ discoveredUrl.url }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="foundOnUrl">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{'INTEGRATIONS.BACKLINK_CRAWLER.FOUND_ON_URL' | translate}}
          </span>
          </th>
          <td mat-cell *matCellDef="let discoveredUrl">
            <div class="fx-row align-items-center justify-content-start">
              @if (discoveredUrl.foundOnUrl) {
                <a target="_blank" [href]="discoveredUrl.foundOnUrl"
                   class="text bold">{{ discoveredUrl.foundOnUrl}}</a>
              } @else {
                <span class="chip green">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.SOURCE_URL' | translate }}</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{'INTEGRATIONS.BACKLINK_CRAWLER.STATUS' | translate}}
          </span>
          </th>
          <td mat-cell *matCellDef="let discoveredUrl">
            <div class="fx-row align-items-center justify-content-start">
              @if (discoveredUrl.status) {
                <span [class.green]="discoveredUrl.status === DiscoveredUrlStatus.DONE"
                      [class.red]="discoveredUrl.status === DiscoveredUrlStatus.ERROR"
                      class="chip light">{{
                    'INTEGRATIONS.BACKLINK_CRAWLER.STATUSES.' + discoveredUrl.status | translate
                  }}</span>
              } @else {
                <span class="chip light">{{
                    'INTEGRATIONS.BACKLINK_CRAWLER.STATUSES.' + DiscoveredUrlStatus.UNKNOWN | translate
                  }}</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="depth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{'INTEGRATIONS.BACKLINK_CRAWLER.DEPTH' | translate}}
          </span>
          </th>
          <td mat-cell *matCellDef="let discoveredUrl">
            <div class="fx-row align-items-center justify-content-start">
              <span class="text">{{ discoveredUrl.depth }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{'INTEGRATIONS.BACKLINK_CRAWLER.CREATED_AT' | translate}}
          </span>
          </th>
          <td mat-cell *matCellDef="let discoveredUrl">
            <div class="fx-row align-items-center justify-content-start">
              <time [dateTime]="discoveredUrl.createdAt" class="text light">{{ createdAt(discoveredUrl) }}</time>
            </div>
          </td>
        </ng-container>

        <!-- // TODO validated or not + other controls -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let integration">
            <mat-icon class="dark clickable" matRipple fontSet="material-icons-outlined" [cdkMenuTriggerFor]="menu"
                      roleBasedElement [roles]="['SUPERADMIN','ADMIN','MANAGER']">more_vert</mat-icon>
            <ng-template #menu>
              <mat-card class="menu-container p-0 elevation" cdkMenu>
                <div class="fx-column">
                  <div class="fx-row align-items-center justify-content-start menu-item actionable clickable">
                    <mat-icon class="dark mr-5" fontSet="material-icons-outlined">play_circle</mat-icon>
                    <span class="text">{{'ACTIONS.TRIGGER' | translate}}</span>
                  </div>
                </div>
              </mat-card>
            </ng-template>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let discoveredUrl; columns: displayedColumns;">
        </tr>
      </table>
      @if (!loading && discoveredBacklinksPaginator.totalDocs === 0) {
        <div class="p-16">
          <span class="text light">{{'INTEGRATIONS.BACKLINK_CRAWLER.NO_BACKLINK_FOUND' | translate}}</span>
        </div>
      }
      <mat-paginator [length]="discoveredBacklinksPaginator.totalDocs || 0" [pageSize]="discoveredBacklinksPaginator.limit || 0"
                     [pageIndex]="discoveredBacklinksPaginator && discoveredBacklinksPaginator.page ? (discoveredBacklinksPaginator.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
                     (page)="handlePage($event)">
      </mat-paginator>
    </mat-card>
  }
</div>
